import React from 'react';
const IossOfferDetails = () => (React.createElement("div", { className: 'margin-left-sm margin-top-none pad-top-none' },
    React.createElement("p", { className: 'pad-top-none margin-top-none' }, 'Our IOSS solution doesn\'t include tax calculation, so it works best for businesses who sell on marketplaces'),
    React.createElement("p", { className: 'pad-top-xs' }, "Indirect customs representation may be required")));
export default IossOfferDetails;
